"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../theming/theme.pricing-system");

var TextField = function (_super) {
  __extends(TextField, _super);

  function TextField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TextField.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.generalContainerView
    }, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.labelView
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.labelText
    }, this.props.label)), react_1.default.createElement(react_native_1.TextInput, {
      keyboardType: this.props.number ? 'numeric' : 'default',
      style: this.props.hasError ? theme_pricing_system_1.pricingStyles.errorTextFieldOuterStyling : theme_pricing_system_1.pricingStyles.textFieldOuterStyling,
      onChangeText: this.props.onChangeText,
      value: this.props.value
    }));
  };

  return TextField;
}(react_1.default.Component);

exports.TextField = TextField;